import { Box, Container } from '@chakra-ui/react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './App.css';
// import { selectAuthInfo } from './features/auth/authSlice';
import { useAuth } from 'core';
import { ClientSettingsLandingPage } from 'features/clientSettings';
import { DashboardPage } from 'features/dashboard.page';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
  AfeDetailPage,
  AfeSearchPage,
  BoardProjectDetail,
  BoardProjectSearchPage,
  InvoiceDetailPage,
  InvoiceSearchPage,
  Navbar,
  PurchaseOrderDetailPage,
  PurchaseOrderSearchPage,
  WorkOrderDetailPage,
  WorkOrderSearchPage,
} from './features';

const App = () => {
  const auth = useAuth();

  if (!auth) {
    return <Navigate to="/" />;
  }

  return (
    <Box as="section" height="100vh" overflowY="auto">
      <Navbar />
      <Container
        pt={{ base: '8', lg: '12' }}
        pb={{ base: '12', lg: '24' }}
        minW="100%"
      >
        <Routes>
          {/* Client Settings */}
          <Route
            path="client-settings/*"
            element={<ClientSettingsLandingPage />}
          />
          {/* Board Projects  */}
          <Route
            path="board-projects/search"
            element={<BoardProjectSearchPage />}
          />
          <Route
            path="board-projects/:id/details"
            element={<BoardProjectDetail />}
          />
          <Route
            path="board-projects/*"
            element={<Navigate to="/app/board-projects/search" />}
          />

          {/* AFEs  */}
          <Route path="afes/:id/details" element={<AfeDetailPage />} />
          <Route path="afes/search" element={<AfeSearchPage />} />
          <Route path="afes/*" element={<Navigate to="/app/afes/search" />} />
          {/* Purchase Orders  */}
          <Route
            path="purchase-orders/:id/details"
            element={<PurchaseOrderDetailPage />}
          />
          <Route
            path="purchase-orders/search"
            element={<PurchaseOrderSearchPage />}
          />
          <Route
            path="purchase-orders/*"
            element={<Navigate to="/app/purchase-orders/search" />}
          />
          {/* Work Orders */}
          <Route
            path="work-orders/:id/details"
            element={<WorkOrderDetailPage />}
          />
          <Route path="work-orders/search" element={<WorkOrderSearchPage />} />
          <Route
            path="work-orders/*"
            element={<Navigate to="/app/work-orders/search" />}
          />
          <Route
            path="work-orders"
            element={<Navigate to="work-orders/search" />}
          />
          {/* Invoices  */}
          <Route path="invoices/:id/details" element={<InvoiceDetailPage />} />
          <Route path="invoices/search" element={<InvoiceSearchPage />} />
          <Route
            path="invoices/*"
            element={<Navigate to="/app/invoices/search" />}
          />
          {/* Dashboard */}
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="*" element={<Navigate to="/app/dashboard" />} />
        </Routes>
      </Container>
    </Box>
  );
};

// function App() {
//   const isDesktop = useBreakpointValue({ base: false, lg: true });
//   const breakpointValue = useBreakpointValue({ base: 'xs', lg: 'sm' });

//   const auth = useAuth();
//   const location = useLocation();

//   if (!auth) {
//     return <Navigate to="/login" />;
//   }

//   return (
//     <Flex
//       as="section"
//       direction={{ base: 'column', lg: 'row' }}
//       height="100vh"
//       bg="bg-canvas"
//       overflowY="auto"
//     >
//       {isDesktop ? <SideBar /> : <NavBar />}
//       <Box bg="bg-accent" pt={{ base: '0', lg: '3' }} flex="1">
//         <Stack w="100%" flex="1">
//           <HStack
//             w="100%"
//             flex="1"
//             flexDir="row"
//             justifyContent="end"
//             spacing="24px"
//             p="16px 32px 16px 0"
//           >
//             <UserProfile />
//             <ColorModeButton />
//           </HStack>
//         </Stack>
//         <Box
//           bg="bg-canvas"
//           borderTopLeftRadius={{ base: 'none', lg: '2rem' }}
//           height="full"
//           px="0"
//         >
//           <Container py="8">
//             <Routes>
//               {/* <Route path=":module/details/:id" element={<DetailPage />} />
//                 <Route path=":module/search" element={<SearchPage />} /> */}
//               <Route
//                 path="work-orders/search"
//                 element={<WorkOrderSearchPage />}
//               />
//               <Route path="invoices/search" element={<InvoiceSearchPage />} />
//               <Route
//                 path="invoices/:id/detail"
//                 element={<InvoiceDetailPage />}
//               />
//               <Route path="dashboard" element={<DashboardPage />} />
//               <Route path="*" element={<Navigate to="dashboard" />} />
//             </Routes>
//           </Container>
//         </Box>
//       </Box>
//       <ToastContainer />
//     </Flex>
//   );
// }

export default App;
